import { MaterialIcon } from "components/ui/shared/MaterialIcon"
import styled from "styled-components"

export const AuthenticatingApp = () => {

    return <StyledAuthenticatingApp>
        <div className="authenticatingWrapper">
            <div className="iconContainer">
                <MaterialIcon
                    name='shield_lock'
                    weight={300}
                    size='xxl'
                    color={({theme}) => theme.colors.mutedForeground}
                />
            </div>
            <div className="loadingBar"></div>
            <div className="authenticatingTitle">
                Autentisering
            </div>
            <div className="authenticatingText">
                Verifiserer sikkerhetssertifikater <br/> og sikrer dashbordtilkoblingen din.
            </div>
        </div>
        
    </StyledAuthenticatingApp>
}

const StyledAuthenticatingApp = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: ${({theme}) => theme.colors.neutralSecondaryBackground};
    height: 100%;


    @keyframes moveLoader
    {
        from { transform: translate3d(0, 0, 0); }
        to { transform: translate3d(40px, 0, 0); }
    }

    div.authenticatingWrapper
    {
        display: flex;
        flex-direction: column;
        align-items: center;

        div.iconContainer
        {
            padding: ${({theme}) => theme.spacing.md};
            border-radius: ${({theme}) => theme.cornerRadius.lg};
            filter: drop-shadow(0 2px 2px rgba( ${({theme}) => theme.colors.neutralSecondaryForegroundRGB}, 0.15));
            width: fit-content;
            margin-bottom: ${({theme}) => theme.spacing.lg};
            background: ${({theme}) => theme.colors.neutralPrimaryBorder};

            display: flex;
            align-items: center;
            justify-content: center;
        }

        div.loadingBar
        {
            position: relative;
            overflow: hidden;

            width: 100%;
            height: ${({theme}) => theme.spacing.md};
            margin-bottom: ${({theme}) => theme.spacing.lg};
            border-radius: ${({theme}) => theme.cornerRadius.sm};
            background: ${({theme}) => theme.colors.backgroundSecondary};

            filter: drop-shadow(0 2px 2px rgba( ${({theme}) => theme.colors.neutralSecondaryForegroundRGB}, 0.15));

            &::before
            {
                content: "";

                position: absolute;
                top: 0;
                left: -50px;

                width: calc(100% + 50px);
                height: 100%;

                background:
                    repeating-linear-gradient(
                        90deg,
                        ${({theme}) => theme.colors.mutedForeground} 0 30px,
                        transparent 30px 40px
                    );

                will-change: transform;

                animation: moveLoader 1s linear infinite;
            }
        }

        div.authenticatingTitle
        {
            font-weight: 500;
            font-size: ${({theme}) => theme.fontSize.xl};
            color: ${({theme}) => theme.colors.mutedForeground};
            margin-bottom: ${({theme}) => theme.spacing.md};
        }

        div.authenticatingText
        {
            font-weight: 500;
            font-size: ${({theme}) => theme.fontSize.md};
            color: ${({theme}) => theme.colors.mutedForeground};
        }
        
    }


   /* height: 100%;
    background: ${({theme}) => theme.colors.neutralSecondaryBackground};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;  

    div.centralIcon
    {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        div.iconContainer
        {
            display: flex;
            align-items: center;
            justify-content: center;
            background: ${({theme}) => theme.colors.neutralPrimaryBorder};
            padding: ${({theme}) => theme.spacing.lg};
            margin-bottom: ${({theme}) => theme.spacing.lg};
            border-radius: 9999px;
            //position: absolute;
            //position: absolute;

            svg
            {
                height: ${({theme}) => theme.spacing.xl};
                width: ${({theme}) => theme.spacing.xl};
                //fill: ${({theme}) => theme.colors.accentForeground};
            }
        }
    }

    div.loadingBar
    {
        height: ${({theme}) => theme.spacing.md};
        width: 100%;
        border: 1px solid red;
    }
    
    /*div.centralIcon
    {
        position: relative;
        width: 150px;
        height: 150px;
        //padding: ${({theme}) => theme.spacing.lg};
        margin-bottom: ${({theme}) => theme.spacing.xl};

        &::before
        {
            content: "";
            position: absolute;
            width: 100%;
            height: 100%;
            border: 1px solid blue;
            border-radius: 9999px;
            animation-iteration-count: infinite;
            animation-timing-function: linear;
            animation-name: rotating;
            animation-duration: 2s;
            border: 3px solid ${({theme}) => theme.colors.accentForeground};
            border-bottom: 3px solid ${({theme}) => theme.colors.neutralPrimaryBorder};
        }

        div.iconContainer
        {
            background: ${({theme}) => theme.colors.accentBackground};
            padding: ${({theme}) => theme.spacing.lg};
            border-radius: 9999px;
            position: absolute;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);

            svg
            {
                height: ${({theme}) => theme.spacing.xl};
                width: ${({theme}) => theme.spacing.xl};
                fill: ${({theme}) => theme.colors.accentForeground};
            }
        }
        

        
    }*/
`